export function extractAllExceptByKeys(obj: object, exclude: Array<string>): object {
  return Object.keys(obj).reduce((result, key) => {
    return exclude.includes(key) ? result : { ...result, [key]: obj[key] };
  }, []);
}
